import { LoaderCircle } from 'lucide-react';
import { useCallback, useState } from 'react';

import { LogsFilters } from './components/LogsFilters';
import { LogsTable } from './components/LogsTable';

import { PaginationV2 } from '@/components/PaginationV2';
import { Card, CardContent } from '@/components/ui/Card';
import { useGetAuditLogs } from '@/hooks/useGetAuditLogs';

export function AdminAuditLogs() {
  const [action, setAction] = useState<string>('0');
  const [customerId, setCustomerId] = useState<string>('0');
  const [perPage, setPerPage] = useState(20);

  const onPerPage = useCallback((value: number) => {
    setPerPage(value);
  }, []);

  const { filteredLogs, isLoading, pagination } = useGetAuditLogs({
    customer: customerId !== '0' ? parseInt(customerId, 10) : undefined,
    action: action !== '0' ? action : undefined,
    limit: perPage,
  });

  return (
    <Card className="min-h-screen rounded-lg shadow">
      <CardContent>
        <div className="mt-2 border-b bg-white">
          <div className="container mx-auto px-4 py-6">
            <h1 className="text-2xl font-bold text-gray-900">Audit Logs</h1>
            <p className="mt-1 text-gray-600">
              Track and analyze system activities
            </p>
          </div>
        </div>
        <div className="rounded-lg bg-gray-50">
          <div className="container mx-auto space-y-6 px-4 py-6">
            <Card>
              <CardContent className="p-4">
                <LogsFilters
                  action={action}
                  customerId={customerId}
                  perPage={perPage}
                  onActionChange={setAction}
                  onCustomerChange={setCustomerId}
                  onPerPage={onPerPage}
                />
              </CardContent>
            </Card>

            {filteredLogs.length === 0 && !isLoading && (
              <div className="py-10 text-center text-gray-500">
                No audit logs found.
              </div>
            )}

            {isLoading && (
              <LoaderCircle className="mx-auto mt-10 animate-spin" />
            )}

            {!isLoading && filteredLogs.length > 0 && (
              <LogsTable filteredLogs={filteredLogs} />
            )}

            {!isLoading && (
              <PaginationV2
                className="mt-6"
                hasNextPage={pagination.hasNextPage}
                hasPreviousPage={pagination.hasPreviousPage}
                nextPage={pagination.nextPage}
                previousPage={pagination.previousPage}
                page={pagination.currentPage}
                totalPages={pagination.totalPages}
              />
            )}
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
